angular.module('shared')
.component('emoji', {
    bindings: {
        callback: '&'
     },
    controller: [ "emojiService", "categoriesService", "localStorageService", '$anchorScroll', '$location',
        
        function (emojiService, categoriesService, localStorageService, $anchorScroll, $location){
            
            var ctrl = this;
            ctrl.recentlyUsedEmojis = [];
            ctrl.recently = true;
            ctrl.toggle = {};
            ctrl.searchText = {};
            
            ctrl.$onInit = function(){

                ctrl.pickCategory("people");
                ctrl.recentlyUsedEmojis = localStorageService.getObject("recent-emojis") || [];

                if (ctrl.recentlyUsedEmojis < 1 || ctrl.recentlyUsedEmojis == undefined){
                    ctrl.recently = false;
                }
            };

            ctrl.$onDestroy = function(){
              
                localStorageService.setObject("recent-emojis", ctrl.recentlyUsedEmojis.slice(0,10));
            };

            ctrl.emojiList = emojiService.emojiList;
            
            ctrl.emojiCategories = categoriesService.emojiCategories;
           
            ctrl.convert = function(code){
                return emojiService.convert(code);
            }

            ctrl.filter = (emoji) => {
                if((!ctrl.searchText.category && !ctrl.searchText.keyWords) || 
                (ctrl.searchText.category && ctrl.searchText.category === emoji.category) || 
                (ctrl.searchText.keyWords && ((emoji.name + ' ' + emoji.keyWords.join(' ')).includes(ctrl.searchText.keyWords)))){
                    return true;
                }
                return false;
            }

            ctrl.unPick = function(){
                if(!ctrl.searchText.keyWords){
                    var isAnyTrue = false;
                    for(var key in ctrl.toggle){
                       isAnyTrue = ctrl.toggle[key] ? true : isAnyTrue;
                    }
                    if(isAnyTrue === false){
                        ctrl.pickCategory("people");
                    }
                }
                else{
                    ctrl.searchText.category = '';
                    ctrl.unpickClass();
                }  
            }

            ctrl.unpickClass = function(){
                for(var key in ctrl.toggle){
                    ctrl.toggle[key] = false;
                }
            }

            ctrl.pickCategory = function(category){
                ctrl.searchText.category = category; 
                ctrl.searchText.keyWords ='' ;  
                ctrl.unpickClass();
                ctrl.toggle[category] = true;
            }

            ctrl.pickEmoji = function(code){
                var emoji = ctrl.convert(code);
                
                if (!ctrl.recentlyUsedEmojis.includes(code)){
                    ctrl.recentlyUsedEmojis.unshift(code);
                }
                    ctrl.callback({value: emoji});      
            };

            ctrl.gotoTop = function(){
                $location.hash('number1');             
                $anchorScroll();
            }
            

            ctrl.emojiToDisplay = 200;       

            ctrl.loadMore = function() {
                if (ctrl.emojiToDisplay + 100 < ctrl.emojiList.length) {
                    ctrl.emojiToDisplay += 100;
                } else {
                    ctrl.emojiToDisplay = ctrl.emojiList.length;
                }
            };
        }
    ],
    
    templateUrl: 'shared/emoji/templates/emojiTemplate.html'
})